(() => {
  'use strict';
  const initialize = (scope = document) => {
    scope.querySelectorAll('[data-fn-header]').forEach(header => {
      if (header.dataset.sticky === 'true') header.closest('.shopify-section')?.classList.add('fn-header-host--sticky');
    });
    scope.querySelectorAll('[data-fn-announcement]').forEach(bar => {
      if (bar.dataset.initialized) return;
      bar.dataset.initialized = 'true';
      const messages = [...bar.querySelectorAll('.fn-announcement__message')];
      if (messages.length < 2 || bar.dataset.autoplay !== 'true' || matchMedia('(prefers-reduced-motion: reduce)').matches || window.Shopify?.designMode) return;
      let index = 0;
      const timer = setInterval(() => {
        if (!bar.isConnected) {clearInterval(timer);return;}
        if (document.hidden || bar.matches(':hover') || bar.contains(document.activeElement)) return;
        messages[index].hidden = true;
        index = (index + 1) % messages.length;
        messages[index].hidden = false;
      }, parseFloat(getComputedStyle(bar).getPropertyValue('--fn-ann-speed')) * 1000 || 5000);
    });
    if ('IntersectionObserver' in window && !window.Shopify?.designMode) {
      document.documentElement.classList.add('fn-reveal-ready');
      const observer = new IntersectionObserver(entries => entries.forEach(entry => {if(entry.isIntersecting){entry.target.classList.add('fn-is-visible');observer.unobserve(entry.target);}}),{threshold:0.08});
      scope.querySelectorAll('[data-animation="fade"],[data-animation="rise"]').forEach(el=>observer.observe(el));
    }
  };
  document.addEventListener('click', event => {
    const opener = event.target.closest('[data-fn-open]');
    if (opener) {const dialog = document.getElementById(opener.dataset.fnOpen);if(dialog){dialog._fnOpener=opener;dialog.showModal();}return;}
    const closer = event.target.closest('[data-fn-close]');
    if (closer) closer.closest('dialog')?.close();
    if (event.target.tagName === 'DIALOG') {const r=event.target.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)event.target.close();}
  });
  document.addEventListener('close', event => {event.target._fnOpener?.focus();},true);
  document.addEventListener('shopify:section:load', event => initialize(event.target));
  document.addEventListener('shopify:block:select',event=>{const m=event.target.closest('.fn-announcement__message');if(m){m.parentElement.querySelectorAll('.fn-announcement__message').forEach(x=>x.hidden=x!==m);}});
  initialize();
})();
// Refresh the header from Shopify's authoritative cart after a successful add.
document.addEventListener('fn:cart:updated', async () => {
  try {
    const root = (window.Shopify?.routes?.root || '/').replace(/\/?$/, '/');
    const response = await fetch(root + 'cart.js', {headers:{Accept:'application/json'}});
    if (!response.ok) return;
    const cart = await response.json();
    document.querySelectorAll('[data-fn-cart-count]').forEach(node => {node.textContent = String(cart.item_count || 0);node.hidden = !cart.item_count;});
  } catch (_) { /* The visible add-to-cart confirmation remains available. */ }
});
